import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITaskWithJobInfo } from '../../interfaces/task-info';

@Component({
  templateUrl: './duplicate-tasks-dialog.component.html',
  selector: 'duplicate-tasks-dialog',
  styleUrls: ['./duplicate-tasks-dialog.component.scss'],
})
export class DuplicateTasksDialogComponent implements OnInit {
  @Input() tasks: ITaskWithJobInfo[] = [];
  @Input() registrationNumber: string;
  @Input() showDuplicateTaskDialog: boolean = true;
  @Output() continueEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit(): void {}

  cancel() {
    this.continueEmitter.emit(false);
  }

  continue() {
    this.continueEmitter.emit(true);
  }

  gotoJobScreen(jobId: number, orderId: number) {
    window.open('app/jobscreen/' + jobId + '/' + orderId, '_blank');
  }
}
